export const politNavigation = [
    {
      link: "/politicas",
      name: "Términos y condiciones",
      target: "policiesAndConditions",
    },
    {
      link: "/politicas",
      name: "Política de privacidad",
      target: "privacy-policy",
    },
    {
      link: "/politicas",
      name: "Tratamiento de datos",
      target: "data-protection-policy",
    },
  ];